import { DropdownOptions } from 'src/app/components/shared/dropdown/dropdown.component';

export const companyAssociationOptions: DropdownOptions = [
  { display: 'proxy', value: 'proxy' },
  { display: 'owner', value: 'owner' },
  { display: 'other', value: 'other' }
];

export const reasonOptions: DropdownOptions = [
  { display: 'buyingEquipment', value: 'Buying equipment' },
  { display: 'hiringStaff', value: 'Hiring staff' },
  { display: 'financingDebt', value: 'Financing debt' },
  { display: 'buyingRealEstate', value: 'Buying real estate' },
  { display: 'marketing', value: 'Marketing' },
  { display: 'generalLiquidity', value: 'General liquidity' },
  { display: 'purchasingInventory', value: 'Purchasing inventory' },
  { display: 'unexpectedExpenses', value: 'Unexpected expenses' },
  { display: 'expansion', value: 'Expansion' },
  { display: 'other', value: 'Other' },
];

export const channelOptions: DropdownOptions = [
  { display: 'instagram', value: 'Instagram' },
  { display: 'facebook', value: 'Facebook' },
  { display: 'google', value: 'Google' },
  { display: 'digitalads', value: 'Digital ads' },
  { display: 'press', value: 'Press' },
  { display: 'outdoormedia', value: 'Outdoor media' },
  { display: 'radio', value: 'Radio' },
  { display: 'tv', value: 'TV' },
  { display: 'email', value: 'Email' },
  { display: 'sms', value: 'Sms' },
  { display: 'other', value: 'Other' }
];


